import { CognitoIdentityProviderClient, InitiateAuthCommand, SignUpCommand, ConfirmSignUpCommand, ResendConfirmationCodeCommand } from "@aws-sdk/client-cognito-identity-provider";
// import config from "./config.json";
import awsConfig from "./aws-exports";

export const cognitoClient = new CognitoIdentityProviderClient({
  region: awsConfig.region,
});

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const setCookies = async(data) => {
  // send tokens to backend to set cookies 
  const {IdToken, AccessToken, RefreshToken} = data;
  const response = await fetch(`${apiUrl}/auth/set-cookies`, {
      method: 'POST',
      credentials: 'include',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        idToken: IdToken, 
        accessToken: AccessToken, 
        refreshToken: RefreshToken
      })
  });

  const responseData = await response.json();

  if(response.status === 200) {
      // add username to local storage for quick access and also set session_active as true to local storage
      localStorage.setItem('session_active', 'true');
      localStorage.setItem('username', responseData.username);
      localStorage.setItem('contributorType', responseData.contributorType);
  }
};

const removeCookies = async() => {
  // send request to backend to remove cookies
  const response = await fetch(`${apiUrl}/auth/remove-cookies`, {
      method: 'GET',
      credentials: 'include',
      headers: {
          'Content-Type': 'application/json'
      }
  });

  if(response.status === 200) {
      console.log('Session removed successfully');
  } else {
      console.log('Failed to remove session');
  }
};
      

export const signIn = async (username, password) => {
  const params = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: awsConfig.clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };

  try {
    const command = new InitiateAuthCommand(params);
    const { AuthenticationResult } = await cognitoClient.send(command);
    if (AuthenticationResult) {
      await setCookies(AuthenticationResult);
      // sessionStorage.setItem("UID", AuthenticationResult.IdToken || '');
      // sessionStorage.setItem("ATK", AuthenticationResult.AccessToken || '');
      // sessionStorage.setItem("NXT", AuthenticationResult.RefreshToken || '');
      return { success: true, message: "Sign in successful" };
    }
  } catch (error) {
    // Get key from error message
    return { success: false, message: error.message, errorName: error.name};
  }
};

export const checkSession = async() => {

  // send request to backend to check session
  const response = await fetch(`${apiUrl}/auth/check-session`, {
      method: 'GET',
      credentials: 'include',
      headers: {
          'Content-Type': 'application/json'
      }
  });

  if(response.status === 200) {
      return true;
  } else {
      // remove local storage items related to session
      localStorage.removeItem('session_active');
      localStorage.removeItem('username');
      localStorage.removeItem('contributorType');
      return false;
  }
};

export const signOut = async () => {
    try {
        await removeCookies();
        // remove local storage items related to session
        localStorage.removeItem('session_active');
        localStorage.removeItem('username');
        localStorage.removeItem('contributorType');
        return { success: true, message: "Sign out successful" };
    } catch (error) {
        console.error("Error signing out: ", error);
        return { success: false, message: error.message };
    }
};

// NOTE: The attributes for first name and last name are set to N/A for now.
// The user pool has a required attribute for first name and last name.
// This is a workaround to allow sign up without these attributes.
// If you want to use these attributes in the future, you can remove the default values and pass them in as arguments from register.js
export const signUp = async (username, email, password) => {

  const params = {
    ClientId: awsConfig.clientId,
    Username: email,
    Password: password,
    UserAttributes: [
      {
        Name: "email",
        Value: email,
      },
      {
        Name: "preferred_username",
        Value: username,
      }
    ],
  };

  try {
    const command = new SignUpCommand(params);
    const response = await cognitoClient.send(command);
    return { success: true, message:`Sign up success: ${response}` };
  } catch (error) {
    return { success: false, message:`Error signing up: ${error}` };
  }
};

export const confirmSignUp = async (username, code) => {
  const params = {
    ClientId: awsConfig.clientId,
    Username: username,
    ConfirmationCode: code,
  };
  try {
    const command = new ConfirmSignUpCommand(params);
    await cognitoClient.send(command);
    return { success: true, message: "User confirmed successfully" };
  } catch (error) {
    return { success: false, message: `Error confirming user: ${error}` };
  }
};

export const resendConfirmationCode = async (username) => {
    
    const command = new ResendConfirmationCodeCommand({
      ClientId: awsConfig.clientId,
      Username: username,
    });

    try {
      await cognitoClient.send(command);
      console.log("Confirmation code resent successfully");
      return true;
    } catch (error) {
      console.error("Error resending confirmation code: ", error);
      throw error;
    }
    
};